const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/billing.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { object, optional, string } from "valibot";
const searchSchema = object({
  orderId: optional(string())
});
export const Route = createFileRoute("/_app/billing")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: searchSchema
});

// const packages = [
//   { price: 200, quantity: 20, name: "Starter Pack" },
//   { price: 32000, quantity: 50, name: "Small Pack" },
//   { price: 29000, quantity: 100, name: "Medium Pack" },
//   { price: 28000, quantity: 200, name: "Large Pack" },
//   { price: 27000, quantity: 300, name: "Extra Large Pack" },
//   { price: 26000, quantity: 400, name: "Professional Pack" },
//   { price: 25500, quantity: 500, name: "Business Pack" },
//   { price: 25000, quantity: 800, name: "Enterprise Pack" },
//   { price: 24500, quantity: 1000, name: "Premium Pack" },
//   { price: 24000, quantity: 2000, name: "Ultimate Pack" },
//   { price: 23500, quantity: 3000, name: "Mega Pack" },
//   { price: 23000, quantity: 4000, name: "Super Pack" },
// ];